import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'oui-router',
  template: `
    <p>
      router works!
    </p>
  `,
  styles: []
})
export class RouterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
